module.exports = __webpack_public_path__ + "static/media/burger.6507f4a7.svg";